import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
  selectAllSingleAttendeeActivityLog,
  selectFetchingSingleAttendeeActivityLog,
} from 'models/singleAttendeeActivityLog';
import LoadingIndicator from 'components/exhibitorPanel/components/LoadingIndicator';
import NoActivityIndicator from 'components/exhibitorPanel/components/NoActivityIndicator';
import AttendeeActivityLogItem from './AttendeeActivityLogItem';
import AttendeeActivityLogObserver from './AttendeeActivityLogObserver';

const UserActivityLogContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const UserActivityLogTimeItem = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px;
`;

const UserActivityLogTimeColumn = styled.div`
  flex: 1;
  font-weight: bold;
  font-size: 14px;
`;

const UserActivityLogTotalActivityContainer = styled.div`
  border: 1px solid #DBDEE2;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px;
`;

const UserActivityLogTotalActivityDataContainer = styled.div`
  font-weight: bold;
  font-size: 16px;
  padding: 4px;
`;

const UserActivityLogTotalActivityTitleContainer = styled.div`
  font-size: 11px;
  padding: 4px;
`;

const AttendeeActivityLog: FC = () => {
  const { t } = useTranslation();
  const logs = useSelector(selectAllSingleAttendeeActivityLog);
  const fetching = useSelector(selectFetchingSingleAttendeeActivityLog);

  if (logs.length) {
    return (
      <UserActivityLogContainer>
        <UserActivityLogTotalActivityContainer>
          <UserActivityLogTotalActivityDataContainer>
            {logs.length}
          </UserActivityLogTotalActivityDataContainer>
          <UserActivityLogTotalActivityTitleContainer>
            {t('activity_log.activities_on_your_booth ', 'Activities on your booth')}
          </UserActivityLogTotalActivityTitleContainer>
        </UserActivityLogTotalActivityContainer>
        <UserActivityLogTimeItem>
          <UserActivityLogTimeColumn>
            {t('activity_log.time', 'Time')}
          </UserActivityLogTimeColumn>
          <UserActivityLogTimeColumn>
            {t('activity_log.activity', 'Activity')}
          </UserActivityLogTimeColumn>
        </UserActivityLogTimeItem>
        {logs.map((log) => (
          <AttendeeActivityLogItem
            key={log.id}
            log={log}
          />
        ))}
      </UserActivityLogContainer>
    );
  }
  if (!fetching) {
    return (
      <NoActivityIndicator />
    );
  }
  return (
    <LoadingIndicator />
  );
};

export default AttendeeActivityLog;
